import React from 'react';
import StatCard from 'components/StatCard';
import StatCardGroup from 'components/StatCard/StatCardGroup';

const PropertyStatsCards = ({ stats }) => {
	return (
		<div className="property-stats-section">
			<StatCardGroup>
				<StatCard
					title="Open Certificates"
					value={stats.openCertificates}
					icon="bi bi-award"
					color="warning"
				/>
				<StatCard
					title="Open Violations"
					value={stats.openViolations}
					icon="bi bi-exclamation-triangle"
					color="danger"
				/>
				<StatCard
					title="Open Infrastructure"
					value={stats.openInfrastructure}
					icon="bi bi-tools"
					color="info"
				/>
			</StatCardGroup>
		</div>
	);
};

export default PropertyStatsCards;
